export const BABY_SEAT_OPTIONS = [
  '小童用座椅正向安裝',
  '小童用座椅反向安裝',
  '大童用座椅正向安裝',
  '大童用座椅反向安裝',
  '增高墊',
] as const;

export type BabySeatOption = (typeof BABY_SEAT_OPTIONS)[number];
export type BabySeatSelection = Partial<Record<BabySeatOption, number | null>>;

type ParsedBabySeatRequests = {
  babySeatSelection: BabySeatSelection;
  otherSpecialRequests: string[];
};

const BABY_SEAT_LABELS = new Set<string>(BABY_SEAT_OPTIONS);

export function parseSpecialRequestsWithBabySeats(
  specialRequests?: string[] | null
): ParsedBabySeatRequests {
  const babySeatSelection: BabySeatSelection = {};
  const otherSpecialRequests: string[] = [];

  for (const request of specialRequests ?? []) {
    const value = request.trim();
    if (!value) {
      continue;
    }

    const matched = value.match(/^(.*)x(\d+)$/);
    if (matched && BABY_SEAT_LABELS.has(matched[1])) {
      babySeatSelection[matched[1] as BabySeatOption] = Number(matched[2]);
      continue;
    }

    if (BABY_SEAT_LABELS.has(value)) {
      babySeatSelection[value as BabySeatOption] = 1;
      continue;
    }

    otherSpecialRequests.push(value);
  }

  return { babySeatSelection, otherSpecialRequests };
}

export function buildSpecialRequestsWithBabySeats(
  babySeatSelection: BabySeatSelection,
  otherSpecialRequests: string[] = []
): string[] {
  const babySeatRequests = BABY_SEAT_OPTIONS.flatMap((label) => {
    const quantity = babySeatSelection[label];
    if (!Number.isInteger(quantity) || Number(quantity) <= 0) {
      return [];
    }

    return [`${label}x${quantity}`];
  });

  return [...otherSpecialRequests, ...babySeatRequests];
}

export function hasInvalidBabySeatQuantity(babySeatSelection: BabySeatSelection): boolean {
  return BABY_SEAT_OPTIONS.some((label) => {
    if (!(label in babySeatSelection)) {
      return false;
    }

    const quantity = babySeatSelection[label];
    return !Number.isInteger(quantity) || Number(quantity) <= 0;
  });
}
